import { authenticationActions } from '.';

import { func_cookie, func_validation, isAccessTokenValid, isFunction, isNotNullUndefined, isStringEqual_caseInsensitive } from 'functions';
import axios from "axios";
import { useDispatch } from 'react-redux';
import { useAuthenticationActions } from './useAuthentication.actions';

export const promiseInstance = () => {
    return axios.create({
        headers: {
            'content-type': "application/json",
            'appid': "02efd88d61044f4c833c6d43a8cbfb69",
            "authorization": "Bearer " + func_cookie.getCookieValue("access_token_dp")
        },
        baseURL: process.env.REACT_APP_API_URL
    })
};

export const promiseInstance_authorization = async (dispatch, request, callback) => {
    // Validation
    let request_validated = isFunction(request)? request: () => {};
    let callback_validated = isFunction(callback)? callback: () => {};

    let promise = promiseInstance();
    promise.interceptors.response.use(
        response => response, 
        function (error) {
            let status = error?.response?.status;
            let msg = error?.response?.data?.exceptionMessage;

            let isAccessTokenInvalid = func_validation.isStringEqual_caseInsensitive(msg, "Access token expired or invalid");
            let isRefreshTokenExpired = func_validation.isStringEqual_caseInsensitive(msg, "Refresh token expired");

            if ((status === 400) &&
                (isAccessTokenInvalid || isRefreshTokenExpired)) {

                let promise_dataflow = () => {
                    dispatch(request_validated({ isRetrying: true }));
                    callback_validated(promiseInstance());
                }
                if (func_validation.isAccessTokenValid("access_token_dp") && (!isRefreshTokenExpired)) {
                    promise_dataflow();
                }
                else {
                    dispatch(request_validated());
                    
                    dispatch(authenticationActions.refreshAccessToken(
                        promise_dataflow,
                        promise_dataflow
                    ));
                }

                return Promise.reject({});
            }

            return Promise.reject(error);
        }
    );

    callback_validated(promise);
}

export default function usePromiseInstance_authorization() {
    const dispatch = useDispatch();
    const {
        refreshAccessToken
    } = useAuthenticationActions();

    return (request, callback) => {
        // Validation
        let callback_validated = isFunction(callback)? callback: () => {};

        let promise = promiseInstance();
        promise.interceptors.response.use(
            response => response, 
            function (error) {
                let status = error?.response?.status;
                let msg = error?.response?.data?.exceptionMessage;

                let isAccessTokenInvalid = isStringEqual_caseInsensitive(msg, "Access token expired or invalid");
                let isRefreshTokenExpired = isStringEqual_caseInsensitive(msg, "Refresh token expired");

                if ((status === 400) &&
                    (isAccessTokenInvalid || isRefreshTokenExpired)) {

                    let promise_dataflow = () => {
                        if (isFunction(request)) dispatch(request({ isRetrying: true }));
                        callback_validated(promiseInstance());
                    }
                    if (isAccessTokenValid("access_token_dp") && (!isRefreshTokenExpired)) {
                        promise_dataflow();
                    }
                    else {
                        refreshAccessToken(
                            promise_dataflow,
                            promise_dataflow
                        );
                    }

                    return Promise.reject({});
                }

                return Promise.reject(error);
            }
        );

        callback(promise);
    }
}